import auth from './auth';
import firestore from './firestore';
import storage from './storage';

export default { auth, firestore, storage };
